import omit from "lodash.omit";
import querystring from "querystring";

/*
 * Include all query params except for id when pointing back to the offers page
 *
 * document is passed in for testing purposes (was unable to mock correctly), and should
 * not be passed in normal execution
 */
function allOtherQueryParams(paramToRemove: string, documentEl = document): string {
    const params = querystring.parse(documentEl.location.search.substring(1));

    if (Object.keys(params).length === 0) {
        return "";
    }

    const filteredParams = omit(params, paramToRemove);

    if (Object.keys(filteredParams).length === 0) {
        return "";
    }

    return `?${ querystring.stringify(omit(params, paramToRemove)) }`;
}

export default allOtherQueryParams;
